/*
**************************** 
홈페이지 네비게이션
*****************************
*/

import axios from "axios"
import React, { useEffect, useState } from "react"
import cookie from "react-cookies"
import { Link, useLocation, useNavigate } from "react-router-dom"
import BuyLogin from "./BuyLogin"
import Login from "./Login"
import Profile from "./Profile"
import Regist from "./Regist"
import TokTokRegist from "./TokTokRegist"

const imgLogo = {
    height: "auto",
    width: "200px"
}

export default function Navi() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLogin, setLogin] = useState({ state: "false", userName: "", id: -1 });

    useEffect(() => {
        const state = sessionStorage.getItem("state");
        const userName = sessionStorage.getItem("userName");
        const id = sessionStorage.getItem("userId");

        if (state === "true") {
            let copyLogin = { ...isLogin, state: state, userName: userName, id: id };
            setLogin(copyLogin)
        }

    }, [sessionStorage.getItem("state")]);

    useEffect(() => {
        const state = sessionStorage.getItem("state");
        const userName = sessionStorage.getItem("userName");
        const id = sessionStorage.getItem("userId");
        window.GitpleConfig = { "appCode": "NJQVaKwQGKRNUnYvEdVABugBE85z23" };

        if (state === 'true') {
            window.Gitple('update', {
                id: id,
                name: userName,

            });
        } else {
            window.Gitple('boot');
        }

        window.Gitple('changeTooltip', '', { hide: true });

    }, [sessionStorage.getItem("state")]);

    const addKakaoChannel = () => {
        if (window.Kakao) {
            //카카오 스크립트가 로드된 경우
            const kakao = window.Kakao;
            //인증이 안되어있는 경우 인증한다.
            if (!kakao.isInitialized()) {
                kakao.init(process.env.REACT_APP_SHARE_KAKAO_LINK_KEY);
            }

            kakao.Channel.addChannel({
                channelPublicId: '_uZsdG', //카카오 채널 ID
            });
        }
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.4.0/kakao.min.js'; //script 실행 src
        script.integrity = "sha384-mXVrIX2T/Kszp6Z0aEWaA8Nm7J6/ZeWXbL8UpGRjKwWe56Srd/iyNmWMBhcItAjH";
        script.crossOrigin = "anonymous";
        script.async = true; //다운완료시 바로 실행
        document.body.appendChild(script); //태그 생성 (크롬에서 확인 가능)
    }, []);

    //counter 연동부분
    useEffect(() => {
        const counter = cookie.load("l4box");

        if (counter == undefined) {

            const expires = new Date();
            expires.setMinutes(expires.getHours + 24);
            cookie.save("l4box", "counter", {
                path: '/',
                expires: expires,


            });
            addCounter();
        }
    });

    const addCounter = async function () {
        const reqSql = "/api/visitant";
        await axios.post(reqSql, null, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.status === 200) {
            } else {
                console.log(res.status);
            }
        }).catch(function (err) {
            console.log(err);
        });
    }

    const handleBack = (event) => {

        console.log(event);
        event.preventDefault();
        event.returnValue = '';
    };

    useEffect(() => {

        window.addEventListener('popstate', handleBack);
        window.onpopstate = () => {

            const buyLocation = sessionStorage.getItem("buyLocation");
            if (buyLocation == "BuyTocTocBox" || buyLocation == "BuyAccesory") {
                window.history.pushState(null, '', "/" + buyLocation);
                window.location.href = "/" + buyLocation;
                sessionStorage.setItem("buyLocation", "");
            }
        }

        // 컴포넌트 언마운트 시 리스너 제거
        return () => {
            window.removeEventListener('popstate', handleBack);
        };
    });

    const logOut = async function () {
        const reqSql = "/api/users/logout";
        await axios.post(reqSql, null, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.status === 200) {
                sessionStorage.setItem("state", "false");
                sessionStorage.setItem("userId", -1);
                sessionStorage.setItem("userName", "");
                sessionStorage.removeItem("buyType");
                sessionStorage.removeItem("buyTarget");
                sessionStorage.removeItem("buyLocation");
                sessionStorage.removeItem("userType");


                window.location.href = "/";
            } else {
                if (res.status === 204) {
                    alert("로그아웃 실패");
                } else {
                    alert("로그아웃 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("로그아웃 도중 오류가 발생하였습니다.");
        });
    }

    const MyInfo = function () {
        return (
            <div className="btn-group me-4">
                <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    {sessionStorage.getItem("userName")}
                </button>
                <ul className="dropdown-menu">
                    <li><Link className="dropdown-item small" to="#" data-bs-toggle="modal" data-bs-target="#profile">회원정보</Link></li>
                    <li><Link className="dropdown-item small" to="/buylist" data-bs-dismiss="offcanvas" onClick={() => {
                        navigate("/buylist")
                    }}>구매조회</Link></li>
                    <li><Link className="dropdown-item small" to="#" data-bs-toggle="modal" data-bs-target="#toktokRegist">시리얼번호 등록</Link></li>
                    <li><hr className="dropdown-divider"></hr></li>
                    <li><Link className="dropdown-item small" href="#" onClick={(e) => {
                        e.preventDefault();
                        logOut();
                    }}>로그아웃</Link></li>
                </ul>
            </div>
        )
    }

    return (
        <div className="container">
            <div>
                <a href="http://toktokbox.co.kr" target="_blank" className="floation-button-toktokbox"><img src="/toktok04.svg"></img></a>
            </div>
            <div id="kakao-talk-channel-add-button"></div>
            <button className="floating-button" onClick={() => {
                addKakaoChannel();
            }}>
                <img src="/kakaoch.svg"></img>
            </button>
            <nav className="navbar navbar-light navbar-expand-lg bg-white fixed-top py-4">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/" onClick={() => {
                        navigate("/");
                    }}><img src="/img/logo.png" style={imgLogo}></img></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="offcanvasNavbarLabel"></h5>
                            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body " >
                            <ul className="navbar-nav justify-content-center flex-grow-1 fw-bolder fs-5">
                                <li className="nav-item dropdown ms-5 ">

                                    <Link className="nav-link fs-5" href="#" id="offcanvasNavbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        톡톡박스
                                    </Link>
                                    <ul className="dropdown-menu " aria-labelledby="offcanvasNavbarDropdown">
                                        <li><Link to="/brand" className="dropdown-item medium " data-bs-dismiss="offcanvas" onClick={() => {
                                            navigate("/brand");
                                        }}>톡톡박스</Link></li>

                                        <li className="dropdown dropend" id="sub1" ><Link className="dropdown-item medium " href="#" aria-expanded="false">악세사리</Link>

                                        </li>
                                        <ul className="navbar-nav justify-content-start">
                                            <div className="list-group-flush w-100">
                                                <li><Link to="/toktokpen" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                    navigate("/toktokpen");
                                                }}>톡톡펜</Link></li>
                                                <li><Link to="/ssukssukpen" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                    navigate("/ssukssukpen");
                                                }} >쑥쑥펜</Link></li>
                                                <li><Link to="/eraser" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                    navigate("/Eraser");
                                                }} >쓱싹 지우개</Link></li>
                                            </div>
                                        </ul>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown  ms-5">
                                    <Link className="nav-link fs-5" href="#" id="offcanvasNavbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        톡톡 플러스+
                                    </Link>
                                    <ul className="dropdown-menu " aria-labelledby="offcanvasNavbarDropdown">
                                        <li className="dropdown dropend" id="sub1" ><a className="dropdown-item medium " href="#" aria-expanded="false">톡톡 콘텐츠</a>

                                            <ul className="navbar-nav justify-content-start">

                                                <div className="list-group-flush w-100">
                                                    <li><Link to="/toktoklearn" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/toktoklearn");
                                                    }}>톡톡 배움터</Link></li>
                                                    <li><Link to="/toktokplay" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/toktokplay");
                                                    }} >톡톡 놀이터</Link></li>
                                                    <li><Link to="/toktoklive" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/toktoklive");
                                                    }} >톡톡 라이브</Link></li>
                                                </div></ul>

                                        </li>


                                        <li className="dropdown dropend"  ><a className="dropdown-item medium " href="#" aria-expanded="false">톡톡 스쿨</a>
                                            <ul className="navbar-nav justify-content-start">
                                                <div className="list-group-flush w-100">
                                                    <li><Link to="/english" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/english");
                                                    }}>영어</Link></li>
                                                    <li><Link to="/korlang" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/korlang");
                                                    }}>한글</Link></li>
                                                    <li><Link to="/chnlang" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/chnlang");
                                                    }}>중국어</Link></li>
                                                    <li><Link to="/readbook" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/ReadBook");
                                                    }} >독서</Link></li>
                                                    <li><Link to="/playeducation" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/playeducation");
                                                    }} >놀이교육</Link></li>
                                                    <li><Link to="/math" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/Math");
                                                    }} >수학</Link></li>
                                                    <li><Link to="/kidshomet" className="dropdown-item small" data-bs-dismiss="offcanvas" onClick={() => {
                                                        navigate("/kidshomet");
                                                    }} >키즈 홈트</Link></li>
                                                </div>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item dropdown ms-5">
                                    <Link className="nav-link fs-5 fw-bolder" href="#" id="offcanvasNavbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        구매하기
                                    </Link>
                                    <ul className="dropdown-menu" aria-labelledby="offcanvasNavbarDropdown">
                                        <li><Link className="dropdown-item medium " to="/BuyTocTocBox" data-bs-dismiss="offcanvas" onClick={() => {

                                            navigate("/BuyTocTocBox");
                                        }}>톡톡박스</Link></li>
                                        <li className="dropdown-item medium" data-bs-dismiss="offcanvas" onClick={function () {

                                            navigate("/BuyAccesory");
                                        }}>악세사리</li>
                                        <li className="dropdown-item medium" data-bs-dismiss="offcanvas" onClick={function () {

                                            navigate("/BuyContent");
                                        }}>콘텐츠 구독권</li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown ms-5">
                                    <Link className="nav-link fs-5" href="#" id="offcanvasNavbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        커뮤니티
                                    </Link>
                                    <ul className="dropdown-menu" aria-labelledby="offcanvasNavbarDropdown">
                                        <li><Link className="dropdown-item medium " to="/community/notice/1/list" data-bs-dismiss="offcanvas" onClick={() => {
                                            navigate("/community/notice/1/list");
                                        }}>공지사항</Link></li>

                                    </ul>
                                </li>
                                <li className="nav-item dropdown ms-5">
                                    <Link className="nav-link fs-5" href="#" id="offcanvasNavbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        고객센터
                                    </Link>
                                    <ul className="dropdown-menu" aria-labelledby="offcanvasNavbarDropdown">
                                        <li><Link className="dropdown-item medium " to="/Faq" data-bs-dismiss="offcanvas" onClick={() => {
                                            navigate("/Faq")
                                        }}>FAQ</Link></li>
                                        <li><Link className="dropdown-item medium " to="/자료실" data-bs-dismiss="offcanvas" onClick={() => {

                                            alert("준비 중입니다");
                                        }}>자료실</Link></li>

                                    </ul>
                                </li>
                            </ul>

                            <div className="d-flex justify-content-center">
                                {isLogin.state === "false" ? <Link className="nav-link me-3 text-muted medium fw-bolder p-2" to="#" data-bs-toggle="modal" data-bs-target="#exampleModal" >로그인</Link> : null}
                                {isLogin.state === "false" ? <Link className="nav-link me-3 text-muted medium fw-bolder p-2" to="#" data-bs-toggle="modal" data-bs-target="#regist" onClick={() => {

                                }}>회원가입</Link> : null}
                                {isLogin.state === "true" ? <MyInfo></MyInfo> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <Login></Login>
            <Regist></Regist>
            <Profile ></Profile>
            <TokTokRegist ></TokTokRegist>
            <BuyLogin></BuyLogin>
        </div>
    )
}